import {hierarchy} from 'd3-hierarchy';
import {mixedMeasure} from './index';
import {summarize} from '../../modules/transform';

function aggregateMixed (reverse = false, useHierarchy = true) { //dimension이 0–1개인 경우만 고려
  let data = this.data();
  let dimensions = this.dimensions();
  let measures = this.measures();
  let results;
  if(dimensions.length === 0) {
    results = measures.map(m => {
      let value = summarize[m.op](data, d => d[m.field]);
      let result = {};
      result.key = m.field;       //result[mixedDimension.field] = m.field;
      result.value = {};
      result.value[mixedMeasure.field] = value;
      return result;
    });   
  } else { //dimension 있는 경우 
    //reverse 아닌 경우 
    results = this.aggregate(data, true, false, false, false);
    if (reverse) {
      results = measures.map(function(m) {
        let result = {};
        result.key = m.field;
        result.values = results.map(function (d) { 
          let result = {};
          result.key = d.key;
          result.value = {};
          result.value[mixedMeasure.field] = d.value[m.field + '-' + m.op];
          return result;
        });
        return result;
      });
    } else {
      results.forEach(function(d) {
        d.values = measures.map(function(m) { //FIXME: nested 되도록 변화
          let result = {};
          result.key = m.field;
          result.value = {}
          result.value[mixedMeasure.field] = d.value[m.field + '-' + m.op];
          return result;
        });
        delete d.value;
      })
    }
  }
  return useHierarchy ? hierarchy({values: results}, d=> d.values).children : results;
}

export default aggregateMixed;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/aggregateMixed.js